import { Task, TaskPriority } from "@/models";
import { TaskApiDTO } from "../dtos";

export const mapTaskDTOToTask = (taskDTO: TaskApiDTO): Task => {
  return {
    _id: taskDTO._id,
    taskTypeId: taskDTO.taskTypeId,
    priority: taskDTO.priority as TaskPriority,
    userId: taskDTO.userId,
    description: taskDTO.description,
    roomId: taskDTO.roomId,
    bookingId: taskDTO.bookingId,
    username: taskDTO.username ?? "",
    roomName: taskDTO.roomName ?? "",
    date: new Date(taskDTO.date),
  };
};
